import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LoginPage from "../components/LoginPage";
import SettingsPage from "../components/SettingsPage";
import ServerSettings from "../components/ServerSettings";
import AddCar from "../components/AddCar";
import CarList from "../components/CarList";
import BackButton from "../components/BackButton";

function AdminPage() {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [authChecking, setAuthChecking] = useState(true);
  const [view, setView] = useState("settings"); // "settings" | "addcar" | "cars" | "server-settings"

  const savedHost = (
    localStorage.getItem("backendHost") ||
    import.meta.env.VITE_DEFAULT_HOST ||
    window.location.origin
  ).replace(/\/+$/, "");

  // Session beim Laden prüfen — stellt Auth nach F5 wieder her
  useEffect(() => {
    fetch(`${savedHost}/api/auth/status`, { credentials: "include" })
      .then((res) => res.json())
      .then((data) => {
        if (data.isAuthenticated) setIsAuthenticated(true);
      })
      .catch(() => {})
      .finally(() => setAuthChecking(false));
  }, [savedHost]);

  const handleLogout = async () => {
    try {
      await fetch(`${savedHost}/api/auth/logout`, {
        method: "POST",
        credentials: "include",
      });
    } catch (err) {
      console.error("[AUTH] Logout fehlgeschlagen:", err);
    }
    setIsAuthenticated(false);
    setView("settings");
  };

  if (authChecking) {
    return null;
  }

  if (!isAuthenticated) {
    return (
      <LoginPage
        onLoginSuccess={() => setIsAuthenticated(true)}
        onClose={() => navigate("/")}
        showRememberMe={true}
      />
    );
  }

  if (view === "server-settings") {
    return (
      <div className="app-container">
        <div className="header">
          <div className="header-content">
            <BackButton onClick={() => setView("settings")} />
            <h1 className="header-title">Einstellungen</h1>
            <div className="header-spacer"></div>
          </div>
        </div>
        <ServerSettings savedHost={savedHost} />
      </div>
    );
  }

  if (view === "addcar") {
    return (
      <div className="app-container">
        <div className="header">
          <div className="header-content">
            <BackButton onClick={() => setView("settings")} />
            <h1 className="header-title">Fahrzeugtemplate erstellen</h1>
            <div className="header-spacer"></div>
          </div>
        </div>
        <AddCar />
      </div>
    );
  }

  if (view === "cars") {
    return (
      <div className="app-container">
        <div className="header">
          <div className="header-content">
            <BackButton onClick={() => setView("settings")} />
            <h1 className="header-title">Fahrzeuge verwalten</h1>
            <div className="header-spacer"></div>
          </div>
        </div>
        <CarList savedHost={savedHost} onAuthError={handleLogout} />
      </div>
    );
  }

  return (
    <div className="app-container">
      <div className="header">
        <div className="header-content">
          <BackButton onClick={() => navigate("/")} />
          <h1 className="header-title">Einstellungen</h1>
          <div className="header-spacer"></div>
        </div>
      </div>
      <SettingsPage
        savedHost={savedHost}
        onAddCar={() => setView("addcar")}
        onShowCars={() => setView("cars")}
        onServerSettings={() => setView("server-settings")}
        onLogout={handleLogout}
      />
    </div>
  );
}

export default AdminPage;
